export interface CognitiveSearch<T> {
  results: Result<T>[]
  facets: Facets
  currentPage: number
  pageCount: number
  pageSize: number
  hasNextPage: boolean
  hasPreviousPage: boolean
  total: number
  firstRowOnPage: number
  lastRowOnPage: number
}

export interface Facets {}

export interface Result<T> {
  score: number
  highlights: null
  document: T
}

export type CrmProject = {
  projectId: string
  projectName: string
  salesLeadNumber: SalesLeadNumber
  accountId: string
  accountName: AccountName
  accountNumber: string
  customerTypeDescription: string
  projectManagerName: ProjectManagerName
  projectStartDate: Date
  projectEndDate: Date
  projectGuid: string
  region: Region
  serviceLine: ServiceLine
  relationshipType: string
  relationshipOwnerName?: string
}

export type CrmAccount = {
  accountId: string
  accountName: string
  accountNumber: string
  relationshipType: string
  relationshipManager: string
  parentAccountName: string
  parentAccountId: string
  country: string
  addressLine1: string
  addressLine2: string
  addressLine3: string
  city: string
  stateOrProvince: string
  postalCode: string
  telephoneNumber: string
}

export enum AccountName {
  AmazonCorporateSecurity = "Amazon Corporate Security",
  AmazonEUSociétéÀResponsabilitéLimitée = "Amazon EU Société à Responsabilité Limitée",
}

export enum ProjectManagerName {
  JamesHenman = "James Henman",
  JosephMatthewBuckley = "Joseph Matthew Buckley",
}

export enum Region {
  Emea = "EMEA",
  GBP = "GB&P",
  Hmrs = "HMRS",
}

export enum SalesLeadNumber {
  Sl00127093 = "SL00127093",
  Sl00129668 = "SL00129668",
}

export enum ServiceLine {
  CSCProtectiveServices = "CSC - Protective Services",
  Cyber = "Cyber",
}
